import { apiGet, ApiCallError } from "./client.js";
import type { ReportRunSummary, ReportPayload } from "./product-types.js";

export async function getLatestReport(
  websiteId: string,
): Promise<ReportRunSummary | null> {
  return apiGet<ReportRunSummary | null>(`/websites/${websiteId}/reports`);
}

export async function getReportById(
  websiteId: string,
  runId: string,
): Promise<ReportRunSummary | null> {
  try {
    return await apiGet<ReportRunSummary>(
      `/websites/${websiteId}/reports/${runId}`,
    );
  } catch (err) {
    if (err instanceof ApiCallError && err.status === 404) return null;
    throw err;
  }
}

export async function getReportPayload(
  websiteId: string,
  runId: string,
): Promise<ReportPayload | null> {
  try {
    return await apiGet<ReportPayload>(
      `/websites/${websiteId}/reports/${runId}/payload`,
    );
  } catch (err) {
    if (err instanceof ApiCallError && err.status === 404) return null;
    throw err;
  }
}
